/* Soxee cart drawer — podłączony do prawdziwego koszyka Shopify (/cart.js).
   1+1 GRATIS: para gratis rozpoznawana po property _gratis lub final_line_price=0.
   Pary spięte property _bundle (zmiana ilości / usunięcie działa na obie).
   Zastępuje koszyk Horizon: przejmuje klik w ikonę koszyka + zdarzenie soxee:cart:open. */
(function () {
  'use strict';
  var root = document.getElementById('soxee-cart-root');
  if (!root) return;

  var CFG = {
    threshold: isNaN(parseInt(root.dataset.threshold, 10)) ? 15000 : parseInt(root.dataset.threshold, 10), // grosze; 0 = darmowa dostawa zawsze
    ship: parseInt(root.dataset.ship, 10) || 0,               // grosze
    resMin: parseInt(root.dataset.resMin, 10) || 10,
    upVariant: root.dataset.upsellVariant || '',
    upName: root.dataset.upsellName || '',
    upPrice: parseInt(root.dataset.upsellPrice, 10) || 0,
    upCompare: parseInt(root.dataset.upsellCompare, 10) || 0,
  };
  var drawer = root.querySelector('.cdrawer');
  var itemsEl = root.querySelector('[data-cd-items]');
  var footEl = root.querySelector('[data-cd-foot]');
  var countEl = root.querySelector('.cd-count');
  var shipEl = root.querySelector('[data-cd-ship]');
  var shipMsg = root.querySelector('.cd-ship-msg');
  var shipBar = root.querySelector('.cdrawer__bar i');
  var lastFocus = null;

  /* ---------- format ---------- */
  function zl(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function para(n) { return n === 1 ? '1 para' : (n < 5 ? n + ' pary' : n + ' par'); }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&quot;').replace(/"/g, '&quot;'); }
  function prop(it, k) { return it.properties && (it.properties[k] || it.properties['_' + k]); }
  // Gratis = linia realnie za 0 zł (po automatycznym rabacie). Property _gratis to tylko
  // znacznik grupujący/intencja — o „GRATIS" w cenie decyduje prawdziwy final_line_price,
  // żeby drawer nie kłamał, dopóki rabat nie jest skonfigurowany.
  function isFree(it) { return it.final_line_price === 0; }

  /* ---------- reservation timer ---------- */
  var K = 'soxee_cart_res', W = CFG.resMin * 60 * 1000;
  var resEnd = parseInt(localStorage.getItem(K) || '0', 10);
  if (!resEnd || resEnd < Date.now()) { resEnd = Date.now() + W; localStorage.setItem(K, String(resEnd)); }
  function resTick() {
    var left = Math.max(0, Math.floor((resEnd - Date.now()) / 1000));
    if (left === 0) { resEnd = Date.now() + W; localStorage.setItem(K, String(resEnd)); left = Math.floor(W / 1000); }
    var t = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2);
    root.querySelectorAll('.cd-res-t').forEach(function (b) { b.textContent = (left < 600 ? '0' : '') + t; });
  }
  resTick(); setInterval(resTick, 1000);

  /* ---------- cart api ---------- */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function addLine(id, qty, props) {
    var body = { items: [{ id: id, quantity: qty || 1, properties: props || {} }] };
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }

  /* ---------- render ---------- */
  var cartCache = null;

  function itemHTML(it) {
    var free = isFree(it);
    var thumb = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">' : '';
    var meta = [];
    if (it.variant_title && it.variant_title !== 'Default Title') meta.push(esc(it.variant_title));
    if (prop(it, 'gratis') || free) meta.push('dodana automatycznie');
    var priceHTML;
    if (free) {
      priceHTML = '<s>' + zl(it.original_line_price) + '</s><b class="free">GRATIS</b>' +
        '<span class="cd-save">(Oszczędzasz ' + zl(it.original_line_price) + ')</span>';
    } else {
      var disc = it.original_line_price > it.final_line_price;
      priceHTML = (disc ? '<s>' + zl(it.original_line_price) + '</s>' : '') + '<b>' + zl(it.final_line_price) + '</b>';
    }
    var qtyHTML = free ? '<div></div>' :
      '<div class="cd-qty" aria-label="Ilość">' +
        '<button class="cd-minus" data-key="' + it.key + '" aria-label="Zmniejsz">−</button>' +
        '<b>' + it.quantity + '</b>' +
        '<button class="cd-plus" data-key="' + it.key + '" aria-label="Zwiększ">+</button></div>';
    return '<div class="cd-item' + (free ? ' cd-item--free' : '') + '" data-key="' + it.key + '" data-bundle="' + esc(prop(it, 'bundle') || '') + '">' +
      '<div class="cd-item__thumb">' + thumb + '</div>' +
      '<div><div class="cd-item__name">' + esc(it.product_title || it.title) + (free ? ' <span class="cd-badge">GRATIS</span>' : '') + '</div>' +
        (meta.length ? '<div class="cd-item__meta">' + meta.join(' · ') + '</div>' : '') +
        '<div class="cd-item__row">' + qtyHTML + '<div class="cd-item__price">' + priceHTML + '</div></div></div>' +
      '<button class="cd-item__rm" data-key="' + it.key + '" aria-label="Usuń z koszyka"><svg viewBox="0 0 24 24" class="ico" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 7h14M10 7V5.5A1.5 1.5 0 0 1 11.5 4h1A1.5 1.5 0 0 1 14 5.5V7m-8 0 1 12.2A2 2 0 0 0 9 21h6a2 2 0 0 0 2-1.8L18 7"/><path d="M10 11v6M14 11v6"/></svg></button>' +
    '</div>';
  }

  function upsellHTML(cart) {
    if (!CFG.upVariant) return '';
    var already = cart.items.some(function (it) { return String(it.variant_id) === String(CFG.upVariant); });
    if (already) return '';
    var price = CFG.upPrice ? '<s>' + (CFG.upCompare ? zl(CFG.upCompare) : '') + '</s><b>' + zl(CFG.upPrice) + '</b>' : '';
    return '<div class="cd-upsell">' +
      '<div class="cd-upsell__thumb"></div>' +
      '<div class="cd-upsell__body"><b>' + esc(CFG.upName || 'Dodaj trzecią parę −30%') + '</b>' +
        '<div class="cd-upsell__price">' + price + '</div></div>' +
      '<button class="cd-add" data-variant="' + CFG.upVariant + '">Dodaj</button></div>';
  }

  function emptyHTML() {
    return '<div class="cd-empty"><svg viewBox="0 0 24 24" class="ico" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 7h14l-1.2 10.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>' +
      '<h6>Twój koszyk jest pusty</h6><p>Wygląda na to, że niczego tu jeszcze nie ma.</p>' +
      '<a href="/collections/all" data-cd-close>Wróć do zakupów</a></div>';
  }

  function render(cart) {
    cartCache = cart;
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    syncHeaderCount(cart.item_count);

    if (!cart.item_count) {
      itemsEl.innerHTML = emptyHTML();
      if (footEl) footEl.hidden = true;
      if (shipEl) shipEl.style.display = 'none';
      return;
    }
    if (shipEl) shipEl.style.display = '';
    if (footEl) footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(itemHTML).join('') + upsellHTML(cart);

    // shipping bar (po rabatach = total_price)
    var total = cart.total_price;
    var free = total >= CFG.threshold;
    if (shipBar) shipBar.style.width = (CFG.threshold > 0 ? Math.min(100, total / CFG.threshold * 100) : 100) + '%';
    if (shipMsg) shipMsg.innerHTML = free ? '<b>Masz darmową dostawę!</b>' :
      'Do <b>darmowej dostawy</b> brakuje <b>' + zl(CFG.threshold - total) + '</b>';
    if (shipEl) shipEl.classList.toggle('ok', free);

    // stopka
    var shipV = root.querySelector('.cd-ship-v');
    if (shipV) { shipV.textContent = free ? 'Darmowa' : (CFG.ship ? zl(CFG.ship) : 'wg wyceny'); shipV.classList.toggle('free', free); }
    var chips = root.querySelector('.cd-chips');
    if (chips) {
      var c = '';
      var freeSum = cart.items.filter(isFree).reduce(function (s, it) { return s + it.original_line_price; }, 0);
      if (freeSum > 0) c += '<span class="cd-chip">1+1 GRATIS (−' + zl(freeSum) + ')</span>';
      var otherDisc = cart.total_discount - freeSum;
      if (otherDisc > 0) c += '<span class="cd-chip">Rabat (−' + zl(otherDisc) + ')</span>';
      chips.innerHTML = c || '<span class="cd-chip">—</span>';
    }
    var totalEl = root.querySelector('.cd-total');
    if (totalEl) totalEl.textContent = zl(cart.total_price);
    var co = root.querySelector('.cd-checkout');
    if (co) co.setAttribute('href', '/checkout');
  }

  function refresh() { return getCart().then(render); }

  /* ---------- mutacje z spinaniem par (_bundle) ---------- */
  function partnerKeys(key) {
    // zwraca klucze linii w tym samym zestawie (_bundle) co `key`
    if (!cartCache) return [key];
    var it = cartCache.items.filter(function (x) { return x.key === key; })[0];
    var b = it && prop(it, 'bundle');
    if (!b) return [key];
    return cartCache.items.filter(function (x) { return prop(x, 'bundle') === b; }).map(function (x) { return x.key; });
  }
  function setQty(key, qty) {
    var keys = partnerKeys(key);
    var chain = Promise.resolve();
    keys.forEach(function (k) { chain = chain.then(function () { return changeLine(k, qty); }); });
    return chain.then(refresh);
  }
  function removeLine(key) {
    var keys = partnerKeys(key);
    var chain = Promise.resolve();
    keys.forEach(function (k) { chain = chain.then(function () { return changeLine(k, 0); }); });
    return chain.then(refresh);
  }

  itemsEl.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var key = b.dataset.key;
    if (b.classList.contains('cd-plus')) { var q = +b.previousElementSibling.textContent + 1; setQty(key, Math.min(99, q)); }
    else if (b.classList.contains('cd-minus')) { var q2 = +b.nextElementSibling.textContent - 1; if (q2 >= 1) setQty(key, q2); else removeLine(key); }
    else if (b.classList.contains('cd-item__rm')) { removeLine(key); }
    else if (b.classList.contains('cd-add')) { addLine(b.dataset.variant, 1).then(refresh); }
  });

  /* ---------- open / close ---------- */
  function open() {
    refresh();
    root.hidden = false;
    lastFocus = document.activeElement;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var close = root.querySelector('.cdrawer__close'); if (close) close.focus();
  }
  function close() {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  // focus trap
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = drawer.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- przejęcie koszyka Horizon + globalne API ---------- */
  window.soxeeOpenCart = open;
  document.addEventListener('soxee:cart:open', open);

  // klik w ikonę/trigger koszyka → otwórz nasz drawer (faza przechwytująca, blokuje Horizon)
  var CART_TRIGGERS = '[data-testid="cart-drawer-trigger"],cart-icon,.header-actions__cart-icon,cart-drawer-component button,[data-cart-drawer-toggle],a[href$="/cart"],a[href*="/cart?"],[href="/cart"]';
  document.addEventListener('click', function (e) {
    var t = e.target.closest(CART_TRIGGERS);
    if (!t) return;
    if (root.contains(t)) return; // nie blokuj linków w naszym drawerze
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open();
  }, true);

  // odśwież licznik w nagłówku Horizon
  function syncHeaderCount(n) {
    document.querySelectorAll('[data-cart-count],.cart-count,.header__cart-count,cart-count').forEach(function (el) {
      el.textContent = n; if (n > 0) el.removeAttribute('hidden');
    });
  }

  // pierwsze pobranie (licznik) — bez otwierania
  refresh();
})();
